module.exports = __webpack_public_path__ + "static/media/wcp_sec.df4bb76f.png";